/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionSourceTypeEnum } from './subscriptionSourceTypeEnum';
import { SubscriptionStateEnum } from './subscriptionStateEnum';
import { SubscriptionTypeEnumV2 } from './subscriptionTypeEnumV2';


export interface SubscriptionHistoryCreationPostSpec { 
    serialNumber: string;
    tenantId?: string;
    erpId?: string;
    sku?: string;
    quantity: number;
    startDate: string;
    endDate: string;
    state: SubscriptionStateEnum;
    genCount: number;
    subscriptionType: SubscriptionTypeEnumV2;
    effectiveStartDate: string;
    effectiveEndDate?: string;
    effectiveState: SubscriptionStateEnum;
    effectiveSku: string;
    effectiveQuantity: number;
    provisioningNotificationId?: number;
    emailId?: string;
    chargeId: string;
    datacenter: string;
    serviceType: string;
    subscriptionSourceType: SubscriptionSourceTypeEnum;
    /**
     * Unique transaction ID for each provisioning notification payload from fastapi
     */
    saasTransactionId?: string;
}
export namespace SubscriptionHistoryCreationPostSpec {
}


